// Lightweight bilingual dictionary (AZ default, EN secondary)

export const STRINGS = {
  az: {
    brand_tagline: "Gümüş • Aksesuar • Geyim",
    nav_jewelry: "Zinət",
    nav_clothing: "Geyim",
    nav_all: "Hamısı",
    nav_account: "Hesab",
    nav_admin: "Admin",
    search_placeholder: "Məhsul axtar...",
    hero_overline: "Sparkle Kolleksiyası",
    hero_title: "Gümüşün zərif parıltısı",
    hero_sub: "925 əyar gümüş zinət əşyaları. Hər detal sizin üçün seçilib.",
    hero_cta: "Kolleksiyaya bax",
    hero_cta2: "Zinət əşyaları",
    featured: "Seçilmiş məhsullar",
    shop_jewelry: "Zinət əşyaları",
    shop_clothing: "Geyim kolleksiyası",
    view_all: "Hamısına bax",
    add_to_cart: "Səbətə at",
    out_of_stock: "Stokda yoxdur",
    in_stock: "Stokda var",
    material: "Material",
    weight: "Çəki",
    clasp: "Kilid",
    size: "Ölçü",
    length: "Uzunluq",
    color: "Rəng",
    code: "Məhsul kodu",
    stock: "Stok",
    pcs: "ədəd",
    choose_size_first: "Ölçü seçin",
    cart: "Səbət",
    cart_empty: "Səbətiniz boşdur",
    subtotal: "Cəmi",
    checkout: "Sifarişi rəsmiləşdir",
    continue_shopping: "Alış-verişə davam et",
    remove: "Sil",
    quantity: "Say",
    // checkout
    checkout_title: "Sifariş",
    contact_info: "Əlaqə məlumatları",
    full_name: "Ad, Soyad",
    phone: "Telefon nömrəsi",
    email_optional: "Email (istəyə bağlı)",
    delivery_address: "Çatdırılma ünvanı",
    city: "Şəhər",
    address_line: "Ünvan (küçə, ev, mənzil)",
    note_optional: "Qeyd (istəyə bağlı)",
    delivery_by_phone: "Çatdırılma ünvanını sifarişdən sonra telefonla dəqiqləşdirəcəyik.",
    payment_method: "Ödəniş üsulu",
    pay_card: "Kartla ödəniş",
    pay_card_note: "Visa · Mastercard · təhlükəsiz bank səhifəsi",
    pay_wallet: "Apple Pay / Google Pay",
    pay_wallet_note: "Telefonunuzdakı kartla bir toxunuşla ödəyin",
    pay_with_card: "Kartla ödə",
    or: "və ya",
    wallet_unavailable: "hazırda əlçatmazdır — kartla ödənişə keçirilirsiniz.",
    wallet_hint: "Ödəniş pəncərəsi epoint.az tərəfindən təmin olunur. Kart məlumatlarınız bizim saytda saxlanılmır.",
    pay_now: "Ödəniş et",
    choose_payment: "Ödəniş üsulunu seçin",
    preparing_payment: "Sifarişiniz hazırlanır...",
    // --- Çatdırılma (Wolt, 2026-10-02) ---
    delivery_section_title: "Çatdırılma",
    delivery_wolt: "Wolt kuryeri ilə çatdırılma",
    delivery_wolt_note: "Hazırda yalnız Bakı daxilində",
    delivery_pickup: "Mağazadan götürəcəyəm",
    delivery_pickup_note: "Pulsuz · vaxtı telefonla razılaşdıracağıq",
    delivery_manual: "Çatdırılmanı telefonla razılaşdıraq",
    delivery_manual_note: "Çatdırılma haqqını sonra ayrıca ödəyəcəksiniz",
    address_street: "Küçə və ev nömrəsi",
    address_street_ph: "məs. Nizami küçəsi 10",
    address_flat: "Mənzil, mərtəbə, giriş, domofon",
    address_flat_ph: "m. 12, 4-cü mərtəbə, 2-ci giriş",
    address_note: "Kuryerə qeyd",
    address_note_ph: "məs. zəng etməyin, yazın; mühafizəyə verin",
    quote_loading: "Çatdırılma qiyməti hesablanır...",
    map_hint: "Nişanı qapınızın üstünə çəkin və ya xəritəyə toxunun",
    map_pin_set: "Kuryer nişanladığınız yerə gələcək",
    geo_button: "Mövqeyimi götür",
    geo_asking: "Mövqeyiniz soruşulur...",
    geo_used: "Kuryer telefonunuzun göstərdiyi yerə gələcək",
    geo_denied: "Mövqe icazəsi verilmədi — nişanı xəritədə ünvanınızın üstünə qoyun",
    geo_far: "Hazırda yazdığınız ünvandan {km} km uzaqdasınız. Kuryer hara gəlsin?",
    geo_far_typed: "Yazdığım ünvana",
    geo_far_here: "Olduğum yerə",
    pin_far: "Nişan yazdığınız ünvandan {km} km uzaqdadır — kuryer NİŞANA gələcək.",
    pin_far_reset: "Nişanı yazdığım ünvana qaytar",
    quote_recognized: "Wolt ünvanı belə tanıdı",
    quote_check_hint: "Düzgün deyilsə, küçəni dəqiqləşdirin.",
    quote_dispatch_note: "Bağlama hazır olanda Wolt kuryeri göndəriləcək.",
    quote_sms_note: "İzləmə linki SMS ilə gələcək.",
    quote_scheduled_note: "Wolt hazırda bağlıdır — kuryer iş saatında göndəriləcək.",
    quote_need: "Ünvanı yazın və çatdırılma qiymətini gözləyin",
    quote_refreshed: "Çatdırılma qiyməti yeniləndi — yoxlayıb yenidən basın",
    quote_alternatives: "Başqa yol seçin:",
    // --- Nişan etiketi, tam ekran xəritə, hədiyyə, vaxt istəyi, son ünvan (2026-10-20) ---
    pin_near: "Nişan: {place} yaxınlığı",
    map_full: "Tam ekran",
    map_done: "Hazırdır",
    gift_toggle: "Başqa adama çatdırılacaq (hədiyyə)",
    gift_name: "Alıcının adı",
    gift_phone: "Alıcının telefonu",
    gift_sms: "Alıcıya izləmə SMS-i göndərilsin",
    gift_sms_note: "Sürprizdirsə söndürün — kuryer yenə də alıcıya zəng edəcək.",
    gift_required: "Alıcının adını və telefonunu yazın",
    pref_title: "Nə vaxt çatdırılsın?",
    pref_asap: "Hazır olan kimi",
    pref_today: "Bu gün",
    pref_tomorrow: "Sabah",
    pref_evening: "18:00-dan sonra",
    pref_call: "Əvvəlcə zəng edin",
    pref_note: "İstəyiniz mağazaya çatır — kuryer bağlama hazır olanda göndərilir.",
    saved_filled: "Əvvəlki sifarişinizdən dolduruldu",
    saved_other: "Başqa ünvan",
    saved_pick: "Əvvəlki ünvanlarınız",
    delivery_offline_note: "Hazırda göndərilə bilmir — dəqiq vaxtı təyin etmək üçün sizinlə əlaqə saxlanılacaq.",
    summary_recipient: "Alıcı",
    summary_pref: "Çatdırılma istəyi",
    delivery_fee_label: "Çatdırılma (Wolt)",
    pickup_free: "Pulsuz",
    delivery_later: "telefonla",
    track_courier: "Kuryeri izlə",
    wolt_waiting: "Kuryer bağlama hazır olanda göndəriləcək",
    wolt_on_way: "Kuryer yoldadır",
    wolt_delivered: "Çatdırıldı",
    payment_slow_hint: "Ödəniş sistemi cavab verir, bir az gözləyin. Səhifəni yeniləməyin.",
    delivery_title: "Çatdırılma haqqı",
    delivery_amount: "Ödəniləcək məbləğ",
    delivery_note: "Kuryerin qiyməti məsafəyə görə hesablanır.",
    delivery_paid_title: "Ödəniş alındı",
    delivery_paid_sub: "Təşəkkür edirik. Sifarişiniz kuryerlə yola salınır.",
    delivery_link_bad: "Link etibarsızdır",
    delivery_link_bad_sub: "Bu ödəniş linki səhvdir və ya vaxtı keçib. Zəhmət olmasa bizimlə əlaqə saxlayın.",
    wallet_confirm_title: "Ödənişi təsdiqləyin",
    wallet_confirm_hint: "Ödənişi tamamlamaq üçün aşağıdakı düyməyə toxunun.",
    close: "Bağla",
    pay_unavailable: "Ödəniş sistemi müvəqqəti əlçatmazdır. Zəhmət olmasa bir azdan yenidən cəhd edin.",
    max_stock_reached: "Stokda bundan çox yoxdur",
    sold_out_badge: "Satılıb",
    remove_sold_to_continue: "Satılmış məhsulu səbətdən silin ki, davam edə biləsiniz.",
    place_order: "Sifarişi təsdiqlə",
    order_summary: "Sifariş xülasəsi",
    discount: "Endirim",
    discount_card_found: "Endirim kartınız tanındı",
    order_total: "Ödəniləcək",
    // order confirmation
    order_received: "Sifarişiniz qəbul edildi!",
    order_number: "Sifariş nömrəsi",
    order_thanks: "Təşəkkür edirik. Tezliklə sizinlə əlaqə saxlanılacaq.",
    pay_ok_title: "Ödənişiniz qəbul edildi",
    pay_ok_sub: "Sifarişiniz hazırlanmağa başlayır. Tezliklə sizinlə əlaqə saxlanılacaq.",
    pay_fail_title: "Ödəniş alınmadı",
    pay_fail_sub: "Məbləğ kartınızdan çıxmayıb. Yenidən cəhd edə bilərsiniz.",
    pay_pending_title: "Ödəniş yoxlanılır",
    pay_pending_sub: "Bank cavabı gözlənilir. Bu səhifəni bir neçə saniyədən sonra yeniləyin.",
    pay_retry: "Yenidən cəhd et",
    pay_check_order: "Sifarişə bax",
    pay_help: "Sualınız varsa bizimlə əlaqə saxlayın.",
    back_home: "Ana səhifəyə qayıt",
    // auth
    login: "Daxil ol",
    register: "Qeydiyyat",
    logout: "Çıxış",
    password: "Şifrə",
    no_account: "Hesabınız yoxdur?",
    have_account: "Hesabınız var?",
    my_orders: "Sifarişlərim",
    welcome: "Xoş gəldiniz",
    // misc
    loading: "Yüklənir...",
    no_products: "Məhsul tapılmadı",
    product_gone_title: "Bu məhsul artıq yoxdur",
    product_gone_sub: "Məhsul satılıb və ya kataloqdan çıxarılıb. Bənzər məhsullara baxa bilərsiniz.",
    filters: "Filtrlər",
    sort_by: "Sırala",
    sort_newest: "Son əlavələr",
    sort_price_asc: "Qiymət: artan",
    sort_price_desc: "Qiymət: azalan",
    all_categories: "Bütün bölmələr",
    details: "Detallar",
    description: "Təsvir",
    footer_about: "Sparkle — əl işi gümüş zinət əşyaları və zərif geyim mağazası.",
    footer_rights: "Bütün hüquqlar qorunur.",
    privacy: "Məxfilik Siyasəti",
  },
  en: {
    brand_tagline: "Silver • Accessories • Apparel",
    nav_jewelry: "Jewelry",
    nav_clothing: "Clothing",
    nav_all: "All",
    nav_account: "Account",
    nav_admin: "Admin",
    search_placeholder: "Search products...",
    hero_overline: "The Sparkle Collection",
    hero_title: "The quiet shine of silver",
    hero_sub: "925 sterling silver jewellery. Every detail chosen for you.",
    hero_cta: "Shop collection",
    hero_cta2: "Jewelry",
    featured: "Featured pieces",
    shop_jewelry: "Jewelry",
    shop_clothing: "Clothing collection",
    view_all: "View all",
    add_to_cart: "Add to cart",
    out_of_stock: "Out of stock",
    in_stock: "In stock",
    material: "Material",
    weight: "Weight",
    clasp: "Clasp",
    size: "Size",
    length: "Length",
    color: "Color",
    code: "Product code",
    stock: "Stock",
    pcs: "pcs",
    choose_size_first: "Select a size",
    cart: "Cart",
    cart_empty: "Your cart is empty",
    subtotal: "Subtotal",
    checkout: "Checkout",
    continue_shopping: "Continue shopping",
    remove: "Remove",
    quantity: "Qty",
    checkout_title: "Checkout",
    contact_info: "Contact information",
    full_name: "Full name",
    phone: "Phone number",
    email_optional: "Email (optional)",
    delivery_address: "Delivery address",
    city: "City",
    address_line: "Address (street, house, apt)",
    note_optional: "Note (optional)",
    delivery_by_phone: "We will confirm your delivery address by phone after the order.",
    payment_method: "Payment method",
    pay_card: "Card payment",
    pay_card_note: "Visa · Mastercard · secure bank page",
    pay_wallet: "Apple Pay / Google Pay",
    pay_wallet_note: "Pay in one tap with the card on your phone",
    pay_with_card: "Pay by card",
    or: "or",
    wallet_unavailable: "is unavailable right now — taking you to card payment.",
    wallet_hint: "The payment window is provided by epoint.az. Your card details are never stored on our site.",
    pay_now: "Pay",
    choose_payment: "Choose how to pay",
    preparing_payment: "Preparing your order...",
    // --- Delivery (Wolt, 2026-10-02) ---
    delivery_section_title: "Delivery",
    delivery_wolt: "Delivery by Wolt courier",
    delivery_wolt_note: "Currently within Baku only",
    delivery_pickup: "I'll pick it up",
    delivery_pickup_note: "Free · we'll agree the time by phone",
    delivery_manual: "Arrange delivery by phone",
    delivery_manual_note: "You'll pay the delivery fee separately later",
    address_street: "Street and house number",
    address_street_ph: "e.g. Nizami street 10",
    address_flat: "Apartment, floor, entrance, intercom",
    address_flat_ph: "apt 12, 4th floor, entrance 2",
    address_note: "Note for the courier",
    address_note_ph: "e.g. don't call, text me; leave with security",
    quote_loading: "Calculating delivery fee...",
    map_hint: "Drag the pin onto your door, or tap the map",
    map_pin_set: "The courier will come to the pinned spot",
    geo_button: "Use my location",
    geo_asking: "Getting your location...",
    geo_used: "The courier will come to your phone's location",
    geo_denied: "Location access was not given — place the pin on your address",
    geo_far: "You are {km} km away from the address you typed. Where should the courier come?",
    geo_far_typed: "To the typed address",
    geo_far_here: "To where I am",
    pin_far: "The pin is {km} km from the address you typed — the courier will go to the PIN.",
    pin_far_reset: "Move the pin back to my address",
    quote_recognized: "Wolt recognized the address as",
    quote_check_hint: "If it's wrong, refine the street.",
    quote_dispatch_note: "A Wolt courier will be sent when your package is ready.",
    quote_sms_note: "You'll get a tracking link by SMS.",
    quote_scheduled_note: "Wolt is closed now — the courier will be sent during working hours.",
    quote_need: "Enter the address and wait for the delivery fee",
    quote_refreshed: "Delivery fee updated — please check and tap again",
    quote_alternatives: "Choose another option:",
    // --- Pin label, full-screen map, gift, time preference, saved address (2026-10-20) ---
    pin_near: "Pin: near {place}",
    map_full: "Full screen",
    map_done: "Done",
    gift_toggle: "Delivering to someone else (gift)",
    gift_name: "Recipient's name",
    gift_phone: "Recipient's phone",
    gift_sms: "Send the recipient a tracking SMS",
    gift_sms_note: "Turn off for a surprise — the courier will still call the recipient.",
    gift_required: "Please enter the recipient's name and phone",
    pref_title: "When should it be delivered?",
    pref_asap: "As soon as it's ready",
    pref_today: "Today",
    pref_tomorrow: "Tomorrow",
    pref_evening: "After 18:00",
    pref_call: "Call me first",
    pref_note: "Your preference goes to the shop — the courier is sent when the package is ready.",
    saved_filled: "Filled from your previous order",
    saved_other: "Different address",
    saved_pick: "Your previous addresses",
    delivery_offline_note: "Delivery can't be sent right now — we'll contact you to set the exact time.",
    summary_recipient: "Recipient",
    summary_pref: "Delivery preference",
    delivery_fee_label: "Delivery (Wolt)",
    pickup_free: "Free",
    delivery_later: "by phone",
    track_courier: "Track courier",
    wolt_waiting: "The courier will be sent when your package is ready",
    wolt_on_way: "The courier is on the way",
    wolt_delivered: "Delivered",
    payment_slow_hint: "The payment provider is responding, please wait. Don't refresh the page.",
    delivery_title: "Delivery fee",
    delivery_amount: "Amount to pay",
    delivery_note: "The courier price depends on the distance.",
    delivery_paid_title: "Payment received",
    delivery_paid_sub: "Thank you. Your order is on its way.",
    delivery_link_bad: "Invalid link",
    delivery_link_bad_sub: "This payment link is wrong or has expired. Please contact us.",
    wallet_confirm_title: "Confirm your payment",
    wallet_confirm_hint: "Tap the button below to complete the payment.",
    close: "Close",
    pay_unavailable: "Payments are temporarily unavailable. Please try again shortly.",
    max_stock_reached: "No more in stock",
    sold_out_badge: "Sold",
    remove_sold_to_continue: "Remove the sold item from your cart to continue.",
    place_order: "Confirm order",
    order_summary: "Order summary",
    discount: "Discount",
    discount_card_found: "Your discount card was recognised",
    order_total: "Total to pay",
    order_received: "Your order has been received!",
    order_number: "Order number",
    order_thanks: "Thank you. We will contact you shortly.",
    pay_ok_title: "Payment received",
    pay_ok_sub: "Your order is being prepared. We will contact you shortly.",
    pay_fail_title: "Payment failed",
    pay_fail_sub: "No money was taken from your card. You can try again.",
    pay_pending_title: "Verifying payment",
    pay_pending_sub: "Waiting for the bank's response. Please refresh this page in a few seconds.",
    pay_retry: "Try again",
    pay_check_order: "View order",
    pay_help: "Contact us if you have any questions.",
    back_home: "Back to home",
    login: "Sign in",
    register: "Register",
    logout: "Logout",
    password: "Password",
    no_account: "No account yet?",
    have_account: "Already have an account?",
    my_orders: "My orders",
    welcome: "Welcome",
    loading: "Loading...",
    no_products: "No products found",
    product_gone_title: "This product is no longer available",
    product_gone_sub: "It has been sold or removed from the catalogue. You can browse similar pieces.",
    filters: "Filters",
    sort_by: "Sort",
    sort_newest: "Newest",
    sort_price_asc: "Price: low to high",
    sort_price_desc: "Price: high to low",
    all_categories: "All categories",
    details: "Details",
    description: "Description",
    footer_about: "Sparkle — handcrafted silver jewelry and refined apparel.",
    footer_rights: "All rights reserved.",
    privacy: "Privacy Policy",
  },
};

export const CATEGORY_LABELS = {
  Ring: { az: "Üzük", en: "Ring" },
  Earrings: { az: "Sırğa", en: "Earrings" },
  Bracelet: { az: "Bilərzik", en: "Bracelet" },
  Earcuff: { az: "Earcuff", en: "Earcuff" },
  Necklace: { az: "Boyunbağı", en: "Necklace" },
  Handchain: { az: "Əl zənciri", en: "Hand chain" },
  Anklet: { az: "Ayaq zənciri", en: "Anklet" },
  "Waist chain": { az: "Bel zənciri", en: "Waist chain" },
  "Body chain": { az: "Body chain", en: "Body chain" },
  "T-shirt": { az: "Tişört", en: "T-shirt" },
  Shirt: { az: "Köynək", en: "Shirt" },
  Skirt: { az: "Ətək", en: "Skirt" },
  Set: { az: "Dəst", en: "Set" },
  Trousers: { az: "Şalvar", en: "Trousers" },
  Blouse: { az: "Bluz", en: "Blouse" },
};

export const catLabel = (cat, lang) =>
  (CATEGORY_LABELS[cat] && CATEGORY_LABELS[cat][lang]) || cat;

export const productName = (p, lang) =>
  lang === "en" ? p.name_en || p.name : p.name || p.name_en;

export const productDesc = (p, lang) =>
  lang === "en" ? p.description_en || p.description : p.description || p.description_en;
